  import { Badge, Button, Col, Row, Table } from 'reactstrap'
import { BasicAlert } from '@g17eco/molecules/alert'
import { SemanticModel, SemanticModelRelationship } from '@api/initiative-data-integrations'

interface TabRelationshipsProps {
  semanticModel: SemanticModel;
  handleDeleteRelationship: (relationshipName: string) => void;
  handleEditRelationship: (relationship: SemanticModelRelationship) => void;
  handleAddRelationship: () => void;
}

export const TabRelationships = (props: TabRelationshipsProps) => {
  const { semanticModel, handleDeleteRelationship, handleEditRelationship, handleAddRelationship } = props;

  return (
    <div className='p-4 border rounded bg-white'>
    <Row className='mb-3'>
      <Col lg={6}>
        <h6>Table Relationships</h6>
        <small className='text-muted'>Define how tables are related to each other</small>
      </Col>
      <Col lg={6} className='d-flex justify-content-end'>
        <Button color='primary' size='sm' onClick={handleAddRelationship}>
          <i className='fal fa-plus me-1' />
          Add Relationship
        </Button>
      </Col>
    </Row>

    {!semanticModel.relationships || semanticModel.relationships.length === 0 ? (
      <BasicAlert type='info'>
        <i className='fal fa-info-circle me-2' />
        No relationships configured yet. Click 'Add Relationship' to define table joins.
      </BasicAlert>
    ) : (
      <Table responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Left Table</th>
            <th>Right Table</th>
            <th>Join Type</th>
            <th>Relationship Type</th>
            <th>Columns</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {semanticModel.relationships.map((relationship, index) => (
            <tr key={index}>
              <td>
                <strong>{relationship.name}</strong>
              </td>
              <td>{relationship.left_table}</td>
              <td>{relationship.right_table}</td>
              <td>
                <Badge color='info'>{relationship.join_type}</Badge>
              </td>
              <td>
                <Badge color='secondary'>{relationship.relationship_type}</Badge>
              </td>
              <td>
                {relationship.relationship_columns.map((col, idx) => (
                  <div key={idx} className='small'>
                    {col.left_column} → {col.right_column}
                  </div>
                ))}
              </td>
              <td>
                <Button
                  color='primary'
                  size='sm'
                  outline
                  onClick={() => handleEditRelationship(relationship)}
                  className='me-1'
                >
                  <i className='fal fa-edit' />
                </Button>
                <Button
                  color='danger'
                  size='sm'
                  outline
                  onClick={() => handleDeleteRelationship(relationship.name)}
                >
                  <i className='fal fa-trash' />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )}
  </div>
  )
}
